import React, { Component } from 'react';
import GuestNavbar from '../navigation/guestnavbar.jsx';
import TermsProd from './TermsProd.jsx';
class termsandConditionProd extends Component {
    render() {
        return (
            <div>
            
                <div>
                    <div className="col-sm-12">
                        <GuestNavbar />
                    </div>
                    <div className="container" style={{ marginTop: "80px" }}>
                        <div className="row">
                            <TermsProd />
                        </div>
                    </div>
                </div>
        </div>
        );
    }
}

export default termsandConditionProd;


// WEBPACK FOOTER //
// ./src/components/termsandcondition/termsandconditionprod.jsx